/** list of keys to use for dnd callbacks */
enum DndCallbackKeys {
	INIT = "init",
	RESET = "reset"
}

const DND_DROP_ZONE_ACTIVATION_CLASS = "csi-drag";

/** object to store dnd callbacks */
const dndCallbacks: Partial<Record<keyof typeof DndCallbackKeys, VoidFunction>> = {};

/** function to register dnd callbacks */
export function registerDndCallback(key: DndCallbackKeys, callback: VoidFunction): void {
	dndCallbacks[key] = callback;
}

/** disable dojo dnd */
export function disableDojoDnd(): void {
	dndCallbacks[DndCallbackKeys.RESET]();
}

/** enable dojo dnd */
export function enableDojoDnd(): void {
	dndCallbacks[DndCallbackKeys.INIT]();
}

/** Set "csi-drag" class on body. Developers supposed to use this class when developing their widgets to indicate drop position */
export function enableDojoDndIndicateDropzone(): void {
	document.body.classList.add(DND_DROP_ZONE_ACTIVATION_CLASS);
}

/** Remove "csi-drag" class on body. Developers supposed to use this class when developing their widgets to indicate drop position */
export function disableDojoDndIndicateDropzone(): void {
	document.body.classList.remove(DND_DROP_ZONE_ACTIVATION_CLASS);
}

/** disable dojo dnd and highlights dnd dropzone,
 * use when we don't need dojo dnd but we want to use it's dropzone,
 * example:
 * <CsiImage
 *   draggable
 *   onDragEnd={handleOnDragEnd}
 *   onDragStart={handleOnDragStart}
 *   src={image.url}
 * />
 * */
export const handleOnDragStart = (): void => {
	disableDojoDnd();
	enableDojoDndIndicateDropzone();
};

/** enable dojo dnd and turnoff dnd dropzone,
 * use when we don't need dojo dnd but we want to use it's dropzone,
 * example:
 * <CsiImage
 *   draggable
 *   onDragEnd={handleOnDragEnd}
 *   onDragStart={handleOnDragStart}
 *   src={image.url}
 * />
 * */
export const handleOnDragEnd = (): void => {
	disableDojoDndIndicateDropzone();
	enableDojoDnd();
};
